import React, { Component } from 'react'
import "./notice.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiGetDeptList , getApiPageresult , getApiGetAllPartition , getApiGetAreaList } from "../../axios/api"
import { Pagination } from 'antd';
import 'antd/dist/antd.css';


export default class notice extends Component {


    state = {
        banner:[],
        list:[],

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:1,

        key:"",
        deptID:"",
        deptName:"",
        partitionStr:"",
        partition:"",

        area:[],
        areaList:[],
        deptList:[],
        partitionList:[],

        showArea:false,
        showMore:false,
        showMore2:false,
    }

    componentWillMount(){
        window.scroll(0,0);

        getApiGetAllPartition()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    partitionList:data
                })

            }
        }).catch( err =>{
            console.error(err);
        })

        getApiGetAreaList({area:"RegisterArea_HDDQ_Jiangsu_NanJin"}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                if(data){
                    this.setState({
                        areaList:data,
                        area:data[3].areaCode
                    })

                    this.getDept();
                }
            }
        }).catch( err =>{
            console.error(err);
        })


        this.changePage(1);
    }

    componentDidMount(){
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();
    }

    getDept=()=>{
        setTimeout(()=>{
            getApiGetDeptList({area:this.state.area}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
            .then( req =>{
                if(req.data.code === 1){
                    let data = req.data.data;
                    if(data){
                        this.setState({
                            deptList:data
                        })
                    }
                }
            }).catch( err =>{
                console.error(err);
            })

            this.changePage(1)
        },20)
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    changePage=(page)=>{
        this.setState({
            page
        })

        setTimeout(()=>{
            this.getList();
        },50)
    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }



    getList=()=>{
        let param = {
            page:this.state.page,
            areaCity:this.state.area,
            dept:this.state.deptID,
            partitionStr:this.state.partition,
        }

        getApiPageresult(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.rows,
                    total:data.total
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='notice'>
                <Header type={2} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>资助公示</p>
                            </div>

                            <div className='hbox'>
                                <div className='hdiv'>
                                    <h2>地区：</h2>
                                    <div className={this.state.showArea?'hflex hauto':'hflex'}>
                                        {/* <div onClick={()=>{this.setState({area:""});this.getDept()}} className={this.state.area === ''?'chosn':""}>全部</div> */}
                                        {
                                            this.state.areaList.map((item,index)=>{
                                                return <div key={index} hidden={index < 3} className={this.state.area === item.areaCode?'chosn':""} onClick={()=>{this.setState({area:item.areaCode,deptID:""});this.getDept()}}>{item.areaName}</div>
                                            })
                                        }

                                        <div className='more' onClick={()=>{this.setState({showArea:!this.state.showArea})}}>
                                            <p>{this.state.showArea?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showArea?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                                <div className='hdiv'>
                                    <h2>发布单位：</h2>
                                    <div className={this.state.showMore?'hflex hauto':'hflex'}>
                                        <div onClick={()=>{this.setState({deptName:"",deptID:""});this.changePage(1)}} className={this.state.deptName === ''?'chosn':""}>全部</div>
                                        {
                                            this.state.deptList.map((item,index)=>{
                                                return <div key={index} className={this.state.deptName === item.deptName?'chosn':""} onClick={()=>{this.setState({deptID:item.deptID,deptName:item.deptName});this.changePage(1)}}>{item.deptName}</div>
                                            })
                                        }

                                        <div hidden={this.state.deptList.length < 6} className='more' onClick={()=>{this.setState({showMore:!this.state.showMore})}}>
                                            <p>{this.state.showMore?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                                <div className='hdiv'>
                                    <h2>项目类别：</h2>
                                    <div className={this.state.showMore2?'hflex hauto':'hflex'}>
                                        <div onClick={()=>{this.setState({partition:"",partitionStr:""});this.changePage(1)}} className={this.state.partitionStr === ''?'chosn':""}>全部</div>
                                        {
                                            this.state.partitionList.map((item,index)=>{
                                                return <div key={index} className={this.state.partitionStr === item.fullName?'chosn':""} onClick={()=>{this.setState({partition:item.value,partitionStr:item.fullName});this.changePage(1)}}>{item.fullName}</div>
                                            })
                                        }

                                        <div className='more' onClick={()=>{this.setState({showMore2:!this.state.showMore2})}}>
                                            <p>{this.state.showMore2?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore2?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='hnum'>
                    <div className='cen'>
                        <div className='hmain'>
                            {/* <div className='htype'>
                                <div className='ht1 chosen'>全部</div>
                                <div className='ht2'>最近7天内截止</div>
                                <div className='ht3'>最近30天内截止</div>
                            </div> */}

                            <h4>共查找到<span>{this.state.total}</span>条信息</h4>
                        </div>
                    </div>
                </div>

                <div className='hpage'>
                    <div className='cen'>
                        <div className='hmain'>
                            <table>
                                <thead>
                                    <tr className='trh'>
                                        <th className='tfd'>资助公示</th>
                                        {/* <th>发布单位</th> */}
                                        <th>发布年份</th>
                                    </tr>
                                    <tr className='trh2'>
                                        <th></th>
                                        {/* <th></th> */}
                                        <th></th>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    {
                                        this.state.list.map((item,index)=>{
                                            return <tr key={index} onClick={()=>{this.gotoPage('/noticeinfo?id='+item.mainID)}}>
                                                        <td className='tfd'>{item.title}</td>
                                                        {/* <td>北京市经济和信息化局</td> */}
                                                        <td>{item.dataYear}</td>
                                                    </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                            <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={10}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
